import { useEffect, useRef, useState } from 'react'
import React from 'react';

const FormattedLink = ({ url }) => {
  const getFormattedDomain = (fullUrl) => {
    try {
      const urlObj = new URL(fullUrl);
      // Extract the domain and remove 'www.' if it exists
      const domain = urlObj.hostname.replace(/^www\./, '');
      return `${domain}...`;
    } catch (error) {
      // Fallback just in case the URL string is malformed
      return 'Lien...';
    }
  };

  return (
    <a 
      href={url} 
      target="_blank" 
      rel="noopener noreferrer"
      className="regulation-link"
    >
      {getFormattedDomain(url)} <span className="external-icon">[↗]</span>
    </a>
  );
};

export function RegulationTextsComponent({ data }) {

    const contentRef = useRef(null);

    const [displayData, setDisplayData] = useState([]);

    useEffect(() => {
        if (data && Array.isArray(data)) {
            // Deduplicate data based on text_id
            const uniqueTexts = [];
            const seenIds = new Set();

            data.forEach(item => {
                // Only add if it has a valid ID and hasn't been seen yet
                if (item.text_id && !seenIds.has(item.text_id)) {
                    uniqueTexts.push(item);
                    seenIds.add(item.text_id);
                }
            });

            setDisplayData(uniqueTexts);
        }
    }, [data]); 

    return (
        <div className="regulation-texts-container module-section">
            <div className="module-section-title">Textes et accords</div>
            <div ref={contentRef} style={{ width: '100%', height: '100%' }}>
                <ul className="regulation-texts-list">
                    {displayData.map((rule, i) => (
                        <li key={rule.text_id || i} className="regulation-texts-item">
                            <p className="regulation-text-name">{rule.text_name}</p>
                            <p className="regulation-text-date">{rule.text_date}</p>
                            {rule.text_link && <FormattedLink className="regulation-text-link" url={rule.text_link}>{rule.text_link}</FormattedLink>}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};